(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('SubSeriesController', SubSeriesController);

    SubSeriesController.$inject = ['$scope', '$state', 'DataUtils', 'SubSeries','NgTableParams'];

    function SubSeriesController ($scope, $state, DataUtils, SubSeries,NgTableParams) {
    	var vm = this;
        vm.subSeries = [{stockName:'Hoàng Diệu',productCode:'HSCT2', productName:'Biên nhận hồ sơ',quantityInventory:'20000',seriesNum:'324245-34634636',reasonModify:'Điều chính cuối kỳ',status:'1'},
                     {stockName:'Hoàng Diệu',productCode:'HSCT2', productName:'Giấy chứng nhận bảo hiểm',quantityInventory:'1500',seriesNum:'324245-34634636;324245-34634636',reasonModify:'Điều chính cuối kỳ',status:'1'}];
//        var vm = this;
//        
//        vm.SubSeries = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
        	/*SubSeries.query(function(result) {
                vm.SubSeries = result;
                if(vm.SubSeries !=null && vm.SubSeries.length > 0){
                	var i;
                	for( i = 0; i < vm.SubSeries.length; i++){
                		if(vm.SubSeries[i].status == 1){
                			vm.SubSeries[i].statusName = true;
                		}else{
                			vm.SubSeries[i].statusName = false;
                		}
                	}
                	vm.tableParams = new NgTableParams({
    					page : 1, // show first page
    					count : 20
    				// count per page
    				}, {
    					filterDelay : 0,
    					dataset : vm.SubSeries
    				});
                }
            });*/
        	vm.tableParams = new NgTableParams({
				page : 1, // show first page
				count : 20
			// count per page
			}, {
				filterDelay : 0,
				dataset : vm.subSeries
			});
        }
    }
})();
